import AbstractDataBuilder from "../../core/AbstractDataBuilder";
import SortOutNormalizersResolver from "./SortOutNormalizersResolver";
export default class SortOutDataBuilder extends AbstractDataBuilder {
    static create() {
        if (undefined === this.builderInstance) {
            this.builderInstance = new this(new SortOutNormalizersResolver());
        }
        return this.builderInstance;
    }
}
